module.exports = __webpack_public_path__ + "static/media/free_movie_health.0da6bb1e.png";